export const prettifyLargeCount = (count, fractionDigits) => {
    let prettyCount = count.toString();
    if (count >= 1e9 ||
        parseFloat((count / 1e6).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 1)) === 1000) {
        prettyCount = `${(count / 1e9).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 1)}B`;
    }
    else if (count >= 1e6 ||
        parseFloat((count / 1000).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 0)) === 1000) {
        prettyCount = `${(count / 1e6).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 1)}M`;
    }
    else if (count >= 100000) {
        prettyCount = `${(count / 1000).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 0)}K`;
    }
    else if (count >= 10000) {
        prettyCount = `${(count / 1000).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 1)}K`;
    }
    else if (count >= 1000) {
        prettyCount = `${(count / 1000).toFixed(fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : 2)}K`;
    }
    else if (fractionDigits !== undefined) {
        prettyCount = count.toFixed(fractionDigits);
    }
    return prettyCount;
};
/** Localized count followed by a noun agreeing with it (`"1,234 Components"`).
 * @param count the number to render
 * @param singular noun used when the count is exactly 1
 * @param plural noun used otherwise; defaults to `singular` + "s"
 */
export const formatCount = (count, singular, plural = `${singular}s`) => `${count.toLocaleString()} ${count === 1 ? singular : plural}`;
/** Capitalize only first letter of the word
 * @param value string to capitalize
 */
export function capitalizeFirstLetter(value) {
    if (!value)
        return value;
    return value[0].toUpperCase() + value.slice(1);
}
/** Check if string is valid integer in range
 * @param value string being checked
 */
export function isValidInt(value) {
    return !isNaN(parseInt(value));
}
export function isObjectKey(key, object) {
    return key in object;
}
/** Compares values for sorting purposes.
 * @param first first value provided by sort function
 * @param second second value provided by sort function
 * @param reverse whether sort is reversed
 */
export function compareValues(first, second, reverse) {
    if (typeof first === "string" && typeof second === "string") {
        if (first.toLowerCase() < second.toLowerCase())
            return reverse ? 1 : -1;
        else if (first.toLowerCase() > second.toLowerCase())
            return reverse ? -1 : 1;
        else
            return 0;
    }
    else {
        if (first < second)
            return reverse ? 1 : -1;
        else if (first > second)
            return reverse ? -1 : 1;
        else
            return 0;
    }
}
export const getDirnameFromComponentPath = (path) => {
    return path.replaceAll("\\", "/").split("/").slice(0, -1).join("/");
};
/** Last segment of a path the user typed or picked, on either separator.
 * NOT for analyzer paths from the report: a POSIX file name may contain `\`.
 * @param path file path, `/` or `\` separated
 */
export const getBasename = (path) => path.split(/[\\/]/).at(-1) || path;
//# sourceMappingURL=common.js.map